import { FormContextValues } from '@dreryk/react-common';
import { Heading, SecondaryText, StyledFlex, Toggle } from '@dreryk/react-components';

import { preInterviewSettingsTranslationKeys } from '../../../../translations';

import { EnabledFieldFormBeanPart } from './EnabledField.types';

const t = preInterviewSettingsTranslationKeys;

type EnabledFieldProps = Readonly<Pick<FormContextValues<EnabledFieldFormBeanPart>, 'register'>>;

export const EnabledField = (props: EnabledFieldProps): JSX.Element => {
   return (
      <StyledFlex gap={'12px'} alignItems={'start'}>
         <Toggle testId={'enabled'} controller={props.register('preInterviewEnabled')} />
         <StyledFlex direction={'column'}>
            <Heading testId={'enablePreInterview'} type={'h2'} content={t.enable} margin={'0px'} />
            <SecondaryText testId={'enablePreInterviewDescription'} text={t.enableDescription} />
         </StyledFlex>
      </StyledFlex>
   );
};
